import * as React from 'react';

export const BOOKMARKLET_SCRIPT =
  "javascript: javascript:(function(){var r=new XMLHttpRequest();r.onreadystatechange=function(){if(r.readyState==4){if(r.status==200){var s=document.createElement('script');s.src='https://a.travel-assets.com/mtt-omg/paandi-deeplink-builder-bookmarklet/Prod/latest/all.min.js?r='+Math.random();document.body.appendChild(s)}else{var html=document.createElement('div');html.id='bookmarklet-not-supported';html.style='display: inline-block;border: 2px dashed #00355f;background: #ffcb00;position: fixed;padding: 2px;right: 10px;color: #00355f;top:0px;z-index:99999;';html.innerHTML='This domain is not supported by the Expedia Deeplink Builder.';document.body.appendChild(html);window.setTimeout(function(){html.remove()},3500)}}};r.open('GET','/go/paandi-version',true);r.send()})();";

interface BookmarkletLinkProps {
  children: JSX.Element;
}

export const BookmarkletLink: React.FC<BookmarkletLinkProps> = ({ children }) => {
  return React.cloneElement(children, { href: BOOKMARKLET_SCRIPT });
};
